import Model from "./Model";
import Auth from "../Auth";
import User from "./User";
import Util from "../../js/tb/Util";


export default class ChangeOrder extends Model
{
    static Key = 'ChangeOrder';

    static normalize(props) {

        // "id": 17,
        //     "type": "Candidate",
        //     "effective_at": "2024-04-20T15:00:24.000000Z",
        //     "created_at": "2024-04-20T15:00:24.000000Z",
        //     "affected_periods": 16,
        //     "original_total_periods": 6,
        //     "new_total_periods": 6,
        //     "original_ended_at": "2024-04-21T23:59:59.000000Z",
        //     "new_ended_at": "2024-04-21T23:59:59.000000Z",
        //     "original_rate": 106.49,
        //     "new_rate": 106.49,
        //     "original_percent_markup": 0.38,
        //     "new_percent_markup": 0.38,
        //     "original_talent_cost": 5037.09,
        //     "net_talent_cost": 3167.38,
        //     "new_talent_cost": 8204.470000000001,
        //     "original_platform_rate": 146.9562,
        //     "new_platform_rate": 146.9562,
        //     "original_contract_value": 6920.460000000001,
        //     "net_contract_value": 4630.02,
        //     "new_contract_value": 11550.480000000001,


        // Current End Date
        // last_segment.ended_at
        // Current Total Hours
        // last_segment.total_hours
        // Tax Classification:
        // last_segment.candidate.tax_type
        // Current Bill Rate
        // last_segment.platform_rate
        // Current Talent Cost Rate
        // last_segment.hourly_rate

        //
        // Timeline
        // Hour Impact
        // (new total hours) - last_segment.total_hours
        // Client Fee Impact
        // ((Hour Impact) * (last_segment.platform_rate - last_segment.hourly_rate)) - last_segment.platform_fee
        // Resource Cost Impact
        // (Hour Impact) * last_segment.hourly_rate
        //
        // Rate
        // Hour Impact
        // (last_segment.total_hours - (est. hours @ old rate)) + (est. hours @ new rate)
        // Client Fee Impact
        // (((est. hours @ old rate) * (last_segment.platform_rate - last_segment.hourly_rate)) + ((est. hours @ new rate) * ((new bill rate) - (new talent cost rate)))) - last_segment.platform_fee
        // Resource Cost Impact
        // (((est. hours @ old rate) * last_segment.hourly_rate) + ((est. hours @ new rate) * (new talent cost rate))) - last_segment.talent_cost
        //
        //
        // Candidate
        // Hour Impact
        // (last_segment.total_hours - (est. hours for prior talent)) + (est. hours for new talent)
        // Client Fee Impact
        // (((est. hours for prior talent) * (last_segment.platform_rate - last_segment.hourly_rate)) + ((est. hours for new talent) * ((new bill rate) - (new talent cost rate)))) - last_segment.platform_fee
        // Resource Cost Impact
        // (((est. hours for prior talent) * last_segment.hourly_rate) + ((est. hours for new talent) * (new talent cost rate))) - last_segment.talent_cost
        //
        // Total Hours Impact
        // sum(Items.HourImpact)
        // Fee Impact
        // sum(Items.Client Fee Impact)
        // Total Cost Impacted
        // sum(Items.Resource Cost Impact)

        props.items = TB.map([...(props.items || [])], item => {

            if (item.original_candidate?.user) {
                item.original_candidate.user = User.make(item.original_candidate.user)
            }
            if (item.new_candidate?.user) {
                item.new_candidate.user = User.make(item.new_candidate.user)
            }

            let original_platform_fee = item.original_contract_value - item.original_talent_cost
            let new_platform_fee = item.new_contract_value - item.new_talent_cost

            switch (item.type) {
                case "Timeline":

                    break;
                case "Rate":
                case "Resource":
                    let segment = TB.first(item.candidate_segments, segment => {
                        return segment.rate === item.original_rate
                            && segment.platform_rate === item.original_platform_rate
                            && segment.ended_at === item.original_ended_at
                            && segment.percent_markup === item.original_percent_markup
                    });
                    // if (segment && !TB.isDefined(item.last_segment_periods)) {
                    //     console.info('setting segment periods',item.type , segment.total_periods)
                    //     item.last_segment_periods = item.new_segment_periods - item.affected_periods;
                    // }
                    if (!TB.isDefined(item.last_segment_periods)) {
                        item.last_segment_periods = item.new_total_periods - item.affected_periods;
                    }

                    break;
            }
            if (!item.id) {
                return {new_platform_fee,original_platform_fee,...item};
            }
            return {
                ...item,
                new_platform_fee,
                original_platform_fee,
                total_periods: item.new_total_periods,
                contract_value: item.new_contract_value,
                talent_cost: item.new_talent_cost,
                ended_at: item.new_ended_at,
                rate: item.new_rate,
                platform_cost: item.new_contract_value,
                platform_fee: new_platform_fee,
                platform_rate: item.new_platform_rate,
                percent_markup: item.new_percent_markup,
            };
        })
        return props;
    }

    static transformItemForRequest = (item) => {

        let resource = {...item};

        switch (item.type) {
            case "Timeline":
                resource = TB.pick({...item}, [
                    'id','type','position_id','total_hours','total_periods',
                    'effective_at', 'ended_at', 'contract', 'signed_contract'
                ])
                break;
            case "Rate":
                resource = TB.pick({...item}, [
                    'id','type','position_id','ended_at', 'effective_at',
                    'rate','hourly_rate', 'percent_markup',
                    'last_segment_periods', 'affected_periods', 'contract', 'signed_contract'
                ])
                if (!TB.isDefined(resource.affected_periods)) {
                    delete resource.affected_periods;
                }
                if (!TB.isDefined(resource.last_segment_periods)) {
                    delete resource.last_segment_periods;
                }
                break;
            case "Candidate":
            case "Resource":
                resource = TB.pick({...item}, [
                    'id','type','position_id','new_talent_id', 'ended_at',
                    'effective_at', 'hourly_rate', 'percent_markup','_rate',
                    'last_segment_periods', 'affected_periods', 'contract', 'signed_contract'
                ]);

                if (!TB.isDefined(resource.affected_periods)) {
                    delete resource.affected_periods;
                }
                if (!TB.isDefined(resource.last_segment_periods)) {
                    delete resource.last_segment_periods;
                }
                break;
        }
        resource = TB.mapValues(resource, (value, key) => {
            if (['ended_at','effective_at'].includes(key) && TB.moment(value).isValid()) {
                return TB.moment(value).toISOString();
            }

            return value;
        });
        if (resource.contract && !(resource.contract instanceof File)) {
            delete resource.contract;
        }
        if (resource.signed_contract && !(resource.signed_contract instanceof File)) {
            delete resource.signed_contract;
        }

        return resource;
    }

    static async createChangeOrderForProject(projectId, params, requestOptions = {}) {

        let user = Auth.registeredClientUser();
        if (!projectId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }

        let order = TB.pick(params, [
            'id',
            'name',
            'notes',
            'contract',
            'started_at',
            'ended_at',
            'items',
        ]);
        order.items = TB.map(order.items, ChangeOrder.transformItemForRequest);

        if (order.contract && !(order.contract instanceof File)) {
            delete order.contract;
        }
        let createRequest = TB.request(
            TB.api_endpoint(`/api/projects/${projectId}/change-orders/store`),
            order
        )
        let hasFile = order.contract && order.contract instanceof File;

        if (!hasFile) {
            TB.map(order.items, item => {
                if ((item.contract && item.contract instanceof File) ||
                    (item.signed_contract && item.signed_contract instanceof File)) {
                    hasFile = true;
                }
            })
        }
        if (hasFile) {
            createRequest = createRequest.headers({
                'Content-Type': 'multipart/form-data'
            });
        }
        let response = await createRequest.post(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.change_order')) {
            throw new Error("Something went wrong");
        }

        return response;
    }
    static async updateChangeOrderForProject(orderId, params, requestOptions = {}) {

        let user = Auth.registeredClientUser();
        if (!orderId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }
        let order = TB.pick({...params}, [
            'id',
            'name',
            'notes',
            'contract',
            'started_at',
            'ended_at',
            'items',
        ]);
        if (order.items) {
            order.items = TB.map(order.items, item => ChangeOrder.transformItemForRequest(item));
        }

        if (order.contract && !(order.contract instanceof File)) {
            delete order.contract;
        }
        let updateRequest = TB.request(
            TB.api_endpoint(`/api/change-orders/${orderId}/update`),
            order
        );
        let hasFile = order.contract && order.contract instanceof File;

        if (!hasFile) {
            TB.map(order.items, item => {
                if ((item.contract && item.contract instanceof File) ||
                    (item.signed_contract && item.signed_contract instanceof File)) {
                    hasFile = true;
                }
            })
        }
        if (hasFile) {
            updateRequest = updateRequest.headers({
                'Content-Type': 'multipart/form-data'
            });
        }


        let response = await updateRequest.post(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.change_order')) {
            throw new Error("Something went wrong");
        }

        return response;
    }

    static async deleteChangeOrderForProject(orderId, requestOptions = {}) {

        let user = Auth.registeredClientUser();
        if (!orderId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }

        const deleteCORequest = TB.request(
            TB.api_endpoint(`/api/change-orders/${orderId}/delete`),
        );

        let response = await deleteCORequest.post(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.project')) {
            throw new Error("Something went wrong");
        }

        return response;
    }

    static async publishChangeOrderForProject(orderId, requestOptions = {}) {

        let user = Auth.registeredClientUser();
        if (!orderId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }

        const publishRequest = TB.request(
            TB.api_endpoint(`/api/change-orders/${orderId}/publish`),
        );

        let response = await publishRequest.post(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.change_order')) {
            throw new Error("Something went wrong");
        }

        return response;
    }



}